export default __webpack_public_path__ + "static/media/kakaoIcon.128af687.png";